export { default } from './IconOrImageCardTemplate';
export { type IconOrImageCardTemplateProps } from './IconOrImageCardTemplate.types';
